import {ANALYZERS_ROUTES} from "@constants"
import {offices, reports, searchID} from "@signals"

import PageWrapper from "Pages/@PageWrapper"
import {resetCustomFilters, responseData} from "Pages/AnalyzersV2/@signals"
import RatingContent from "./Content"
import RatingFilters from "./Filters"
import React, {useEffect, useState} from "react"
import {createPortal} from "react-dom"
import {useSearchParams, useLocation} from "react-router-dom"
import {useSearchDate} from "../@hooks";
import {Box, Skeleton, Typography} from "@mui/material";
import {AppOfficesBlock} from "../../../@components";
import PageWrapperAnalyzers from "../../@PageWrapper/Actions/Analyzers";
import ReportsAutocomplete from "../../@PageWrapper/Actions/Reports";
import VirtualTourButton, {TourOverlay, TOUR_STEPS} from "./VirtualTour";
import RatingDemoData from "./VirtualTour/DemoData";
import {AnalyzerEvolutionModal} from "Pages/AnalyzersV2/@components";


export default function RatingAnalyzer() {

	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		resetCustomFilters()
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	return <PageWrapper
		directsite={false}
		head={`DS Rentacar | ${ANALYZERS_ROUTES.RATING_SUBTITLE}`}
		title={ANALYZERS_ROUTES.TITLE}
		showAnalyzersLinks={true}
		subtitle={ANALYZERS_ROUTES.RATING_SUBTITLE}
		isEmpty={false}
		filters={<RatingFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
			{!searchID.value && <Box sx={{ minWidth: 300, mr: 2 }}>
				<ReportsAutocomplete directsite={false}/>
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rectangular' height={30} />
					: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 2, color: 'secondary.main' }}>
						<AppOfficesBlock sx={{ color: 'black' }} {...office}  /> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
			<PageWrapperAnalyzers/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<RatingContent/>
		{tourActive && !Object.keys(responseData.value || {}).length && <RatingDemoData/>}
		{tourActive && !Object.keys(responseData.value || {}).length && <AnalyzerEvolutionModal isRating={true}/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}